class ScrollToTop{
    constructor(){
        this.scrollToTopBtn = document.querySelector("#scroll-to-top");
        this.scrollToTopBtn.addEventListener("click", this.scrollToTop);    
    }

    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
}
export default ScrollToTop

    

    
